module.exports = __webpack_public_path__ + "img/gy.5bff3f17.jpg";